import { render } from "./NewPayment.vue?vue&type=template&id=9ca6d1f4&ts=true"
import script from "./NewPayment.vue?vue&type=script&lang=ts"
export * from "./NewPayment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__